export default [
  {
    id: 'bcb483c5-5f10-4f67-bf5e-b4eb06d85e95',
    path: 'data-visualization',
    name: 'data-visualization',
    meta: { title: '数据应用' },
    children: [
      {
        id: '234516d2-95c8-4fc3-9bf0-79bc87cc3029',
        path: 'data-set',
        name: 'data-set',
        component: () => {
          return import('../views/dataVisualization/dataSet')
        },
        meta: { title: '数据集' },
      },
      {
        id: 'fe70cfc9-a8cd-44d1-88a0-a1ccafe87329',
        path: 'data-view',
        name: 'data-view',
        component: () => {
          return import('../views/dataVisualization/dataView')
        },
        meta: { title: '指标构图' },
      },
      {
        id: '7c722d78-ac21-4a7f-8eee-389257999fd1',
        path: 'data-dashboard',
        name: 'data-dashboard',
        component: () => {
          return import('../views/dataVisualization/dataDashboard')
        },
        meta: { title: '统计展示' },
      },
    ],
  },
]
